module.exports = __webpack_public_path__ + "img/PC_07.87c8ab68.jpg";